import { ExceptionCode, LoadingStatusType, TypeComponentNoti } from "@/enums/enums";
import {
  ConvertToCustomDashboardGroupModel,
  ConvertToCustomDashboardModel,
  ValidateCustomDashboardTemplate,
} from "@/helper/customDashboardHelper";
import { DownloadExport } from "@/helper/exportHelper";
import { GetMessageExceptionCode } from "@/helper/shareHelper";
import { MerchantId } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import router from "@/router";
import {
  ConvertToAllocationDashBoardCompare,
  ConvertToAllocationDashBoardDetail,
  ConvertToCustomDashboardDetail,
  ConvertToCustomDashboardList,
} from "@/service/customDashboard/customDashboardFacade";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class CustomDashboard extends VuexModule {
  public createCustomDashboardLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateCustomDashboardLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public customDashboardDetail: any = null;
  public customDashboardDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateCustomDashboardGroupLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public customDashboardList: any = [];
  public customDashboardListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public suggestionCustomDashboardNumber: any = null;
  public suggestionCustomDashboardNumberLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateCustomDashboardIsDeleteLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public allocationDashBoardDetail: any = null;
  public allocationDashBoardDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public allocationDashBoardCompare: any = null;
  public allocationDashBoardCompareLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getCreateCustomDashboardLoadingStatus(): LoadingStatusType {
    return this.createCustomDashboardLoadingStatus;
  }
  get getUpdateCustomDashboardLoadingStatus(): LoadingStatusType {
    return this.updateCustomDashboardLoadingStatus;
  }
  get getCustomDashboardDetail(): any {
    return this.customDashboardDetail;
  }
  get getCustomDashboardDetailLoadingStatus(): LoadingStatusType {
    return this.customDashboardDetailLoadingStatus;
  }
  get getUpdateCustomDashboardGroupLoadingStatus(): LoadingStatusType {
    return this.updateCustomDashboardGroupLoadingStatus;
  }
  get getCustomDashboardList(): any {
    return this.customDashboardList;
  }
  get getCustomDashboardListLoadingStatus(): LoadingStatusType {
    return this.customDashboardListLoadingStatus;
  }
  get getSuggestionCustomDashboardNumber(): any {
    return this.suggestionCustomDashboardNumber;
  }
  get getSuggestionCustomDashboardNumberLoadingStatus(): LoadingStatusType {
    return this.suggestionCustomDashboardNumberLoadingStatus;
  }
  get getUpdateCustomDashboardIsDeleteLoadingStatus(): LoadingStatusType {
    return this.updateCustomDashboardIsDeleteLoadingStatus;
  }
  get getAllocationDashBoardDetail(): any {
    return this.allocationDashBoardDetail;
  }
  get getAllocationDashBoardDetailLoadingStatus(): LoadingStatusType {
    return this.allocationDashBoardDetailLoadingStatus;
  }
  get getAllocationDashBoardCompare(): any {
    return this.allocationDashBoardCompare;
  }
  get getAllocationDashBoardCompareLoadingStatus(): LoadingStatusType {
    return this.allocationDashBoardCompareLoadingStatus;
  }

  @Mutation
  public MutationSetcreateCustomDashboardLoadingStatus(status: LoadingStatusType) {
    this.createCustomDashboardLoadingStatus = status;
  }
  @Mutation
  public MutationSetupdateCustomDashboardLoadingStatus(status: LoadingStatusType) {
    this.updateCustomDashboardLoadingStatus = status;
  }
  @Mutation
  public MutationSetCustomDashboardDetailLoadingStatus(status: LoadingStatusType) {
    this.customDashboardDetailLoadingStatus = status;
  }
  @Mutation
  public MutationSetcustomDashboardDetail(customDashboardDetail: any) {
    this.customDashboardDetail = customDashboardDetail;
  }
  @Mutation
  public MutationSetupdateCustomDashboardGroupLoadingStatus(status: LoadingStatusType) {
    this.updateCustomDashboardGroupLoadingStatus = status;
  }
  @Mutation
  public MutationSetcustomDashboardListLoadingStatus(status: LoadingStatusType) {
    this.customDashboardListLoadingStatus = status;
  }
  @Mutation
  public MutationSetCustomDashboardList(customDashboardList: any) {
    this.customDashboardList = customDashboardList;
  }
  @Mutation
  public MutationSetSuggestionCustomDashboardNumberLoadingStatus(status: LoadingStatusType) {
    this.suggestionCustomDashboardNumberLoadingStatus = status;
  }
  @Mutation
  public MutationSetSuggestionCustomDashboardNumber(suggestionCustomDashboardNumber: any) {
    this.suggestionCustomDashboardNumber = suggestionCustomDashboardNumber;
  }
  @Mutation
  public MutationSetUpdateCustomDashboardIsDeleteLoadingStatus(status: LoadingStatusType) {
    this.updateCustomDashboardIsDeleteLoadingStatus = status;
  }

  @Mutation
  public MutationSetAllocationDashBoardDetail(allocationDashBoardDetail: any) {
    this.allocationDashBoardDetail = allocationDashBoardDetail;
  }
  @Mutation
  public MutationSetAllocationDashBoardDetailLoadingStatus(status: LoadingStatusType) {
    this.allocationDashBoardDetailLoadingStatus = status;
  }

  @Mutation
  public MutationSetAllocationDashBoardCompare(allocationDashBoardCompare: any) {
    this.allocationDashBoardCompare = allocationDashBoardCompare;
  }
  @Mutation
  public MutationSetAllocationDashBoardCompareLoadingStatus(status: LoadingStatusType) {
    this.allocationDashBoardCompareLoadingStatus = status;
  }

  @Action
  public DoCreateCustomDashboard(customDashboard: any) {
    if (this.createCustomDashboardLoadingStatus !== LoadingStatusType.Loading) {
      const isValidateCustomDashboardTemplate = ValidateCustomDashboardTemplate(customDashboard);
      if (isValidateCustomDashboardTemplate) {
        this.context.commit("MutationSetcreateCustomDashboardLoadingStatus", LoadingStatusType.Loading);
        const customDashboardTemplate = ConvertToCustomDashboardModel(customDashboard);
        const inputAlert: any = {
          alertMessage: "",
          typeMessage: TypeComponentNoti.Success,
        };
        API.CustomDashboardService.DoCreateCustomDashboard(customDashboardTemplate).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            router.push({
              name: "customDashboardDetail",
              query: { emi: MerchantId().PeakEncryption(), ecdi: res.data.inserted.PeakEncryption() },
            });

            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Create_Success", {
                  number: customDashboardTemplate.number,
                  name: customDashboardTemplate.name,
                }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
            this.context.commit("MutationSetcreateCustomDashboardLoadingStatus", LoadingStatusType.Success);
          } else if (res.data.responseCode.IsSeeOther()) {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
            this.context.commit("MutationSetcreateCustomDashboardLoadingStatus", LoadingStatusType.None);
          }

          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        });
      } else {
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("all_validation"),
            typeMessage: TypeComponentNoti.Error,
          },
          { root: true }
        );
      }
    }
  }

  @Action
  public DoUpdateCustomDashboard(customDashboard: any) {
    if (this.updateCustomDashboardLoadingStatus !== LoadingStatusType.Loading) {
      const isValidateCustomDashboardTemplate = ValidateCustomDashboardTemplate(customDashboard);
      if (isValidateCustomDashboardTemplate) {
        this.context.commit("MutationSetupdateCustomDashboardLoadingStatus", LoadingStatusType.Loading);
        const customDashboardTemplate = ConvertToCustomDashboardModel(customDashboard);
        const inputAlert: any = {
          alertMessage: "",
          typeMessage: TypeComponentNoti.Success,
        };
        API.CustomDashboardService.DoUpdateCustomDashboard(customDashboardTemplate).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Update_Success", {
                  number: customDashboardTemplate.number,
                  name: customDashboardTemplate.name,
                }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
            this.context.commit("MutationSetupdateCustomDashboardLoadingStatus", LoadingStatusType.Success);
          } else {
            if (res.data.exception.code == ExceptionCode.CodeDuplicated) {
              customDashboard.number.validateError = true;
            }
            inputAlert.alertMessage = GetMessageExceptionCode(res.data.exception.code, i18n.t("Report"));
            inputAlert.typeMessage = TypeComponentNoti.Error;
            this.context.commit("MutationSetupdateCustomDashboardLoadingStatus", LoadingStatusType.None);
          }
          this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        });
      } else {
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("all_validation"),
            typeMessage: TypeComponentNoti.Error,
          },
          { root: true }
        );
      }
    }
  }

  @Action
  public DoGetCustomDashboardDetail(customDashboardId: number) {
    if (this.customDashboardDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetCustomDashboardDetailLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.CustomDashboardService.DoGetCustomDashboardDetail(customDashboardId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const customDashboardDetail = ConvertToCustomDashboardDetail(res.data.customDashboardTemplateDetail);
          this.context.commit("MutationSetcustomDashboardDetail", customDashboardDetail);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("MutationSetCustomDashboardDetailLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateCustomDashboardGroup(input: any) {
    if (this.updateCustomDashboardGroupLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetupdateCustomDashboardGroupLoadingStatus", LoadingStatusType.Loading);
      const _input = {
        customDashboardId: input.customDashboardId,
        customDashboardGroup: ConvertToCustomDashboardGroupModel(input.allcationId, input.allocationItemGroup),
      };
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.CustomDashboardService.DoUpdateCustomDashboardGroup(_input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.responseCode.IsSuccess()) {
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Update_Success", {
                  number: input.customDashboardNumber,
                  name: input.customDashboardName,
                }),
                typeMessage: TypeComponentNoti.Success,
              },
              { root: true }
            );
          } else {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.Error,
              },
              { root: true }
            );
          }
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }

        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        this.context.commit("MutationSetupdateCustomDashboardGroupLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetCustomDashboardList(isUseMainDatabase = false) {
    if (this.customDashboardListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetcustomDashboardListLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.CustomDashboardService.DoGetCustomDashboardList(isUseMainDatabase).then((res) => {
        const customDashboardList = ConvertToCustomDashboardList(res.data.customDashboardList);
        this.context.commit("MutationSetCustomDashboardList", customDashboardList);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("MutationSetcustomDashboardListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetSuggestionCustomDashboardNumber() {
    if (this.suggestionCustomDashboardNumberLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetSuggestionCustomDashboardNumberLoadingStatus", LoadingStatusType.Loading);
      API.CustomDashboardService.DoGetSuggestionCustomDashboardNumber().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("MutationSetSuggestionCustomDashboardNumber", res.data.number);
        }
        this.context.commit("MutationSetSuggestionCustomDashboardNumberLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateCustomDashboardIsDelete(input: any) {
    if (this.updateCustomDashboardIsDeleteLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationSetUpdateCustomDashboardIsDeleteLoadingStatus", LoadingStatusType.Loading);
      const inputAlert: any = {
        alertMessage: "",
        typeMessage: TypeComponentNoti.Success,
      };
      API.CustomDashboardService.DoUpdateCustomDashboardIsDelete(input.customDashboardId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Remove_Success", {
                number: input.customDashboardNumber,
                name: input.customDashboardName,
              }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          inputAlert.alertMessage = i18n.t("Remove_Error");
          inputAlert.typeMessage = TypeComponentNoti.Error;
        }
        this.context.dispatch("Alert/SetAlertMessage", inputAlert, { root: true });
        this.context.commit("MutationSetUpdateCustomDashboardIsDeleteLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetAllocationDashBoardDetail(input: any) {
    if (this.allocationDashBoardDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSetAllocationDashBoardDetailLoadingStatus", LoadingStatusType.Loading);
      API.CustomDashboardService.DoGetAllocationDashBoardDetail(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const allocationDashBoardDetail = ConvertToAllocationDashBoardDetail(res.data.dashboard);
          this.context.commit("MutationSetAllocationDashBoardDetail", allocationDashBoardDetail);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("MutationSetAllocationDashBoardDetailLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetAllocationDashBoardCompare(input: any) {
    if (this.allocationDashBoardCompareLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationSetAllocationDashBoardCompareLoadingStatus", LoadingStatusType.Loading);
      API.CustomDashboardService.DoGetAllocationDashBoardCompare(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const allocationDashBoardCompare = ConvertToAllocationDashBoardCompare(res.data.dashboard);
          this.context.commit("MutationSetAllocationDashBoardCompare", allocationDashBoardCompare);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("MutationSetAllocationDashBoardCompareLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetExportAllocationDashBoardDetail(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    API.CustomDashboardService.DoGetExportAllocationDashBoardDetail(input).then((res) => {
      if (res.status.IsSuccess()) {
        DownloadExport(res.data.file);
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }
  @Action
  public DoGetExportAllocationDashBoardCompare(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    API.CustomDashboardService.DoGetExportAllocationDashBoardCompare(input).then((res) => {
      if (res.status.IsSuccess()) {
        DownloadExport(res.data.file);
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }
  @Action
  public DoGetExportAllocationDashBoardCompareMockup(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    API.CustomDashboardService.DoGetExportAllocationDashBoardCompareMockup(input).then((res) => {
      if (res.status.IsSuccess()) {
        DownloadExport(res.data.file);
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }
  @Action
  public DoGetExportAllocationDashBoardDetailMockup(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    API.CustomDashboardService.DoGetExportAllocationDashBoardDetailMockup(input).then((res) => {
      if (res.status.IsSuccess()) {
        DownloadExport(res.data.file);
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }
}
